module.exports = __webpack_public_path__ + "cfb5424fc5ce7405eb9f88fd022649e6.pdf";